import List from './list';
import Product from '../models/product';
import { excuseApi } from '../commons/http';

export const getProducts = async (params) => {
  const res = await excuseApi({
    path: '/products',
    method: 'GET',
    params,
  });
  return res.data;
};

export default class Products extends List {
  async fetch(status = null) {
    const params = {};
    if (status && status !== 'all') {
      params.status = status;
    }
    const res = await excuseApi({
      path: '/products',
      method: 'GET',
      params,
    });
    if (res.status === 200) {
      this.mapData(res.data.data);
    }
  }

  mapData(data=[]) {
    for (const item of data) {
      const product = new Product();
      product.mapData(item);
      this.add(product);
    }
  }
}
